import React from 'react';

export default function PieChart(props) {
    return (
        <svg 
            width="19" 
            height="20" 
            viewBox="0 0 19 20" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path 
                d="M17.0077 13.2416C16.4775 14.4954 15.6483 15.6001 14.5926 16.4594C13.5368 17.3186 12.2867 17.9061 10.9514 18.1706C9.61611 18.4351 8.23638 18.3684 6.93281 17.9765C5.62925 17.5845 4.44155 16.8792 3.47354 15.9222C2.50554 14.9652 1.7867 13.7856 1.37989 12.4866C0.973073 11.1876 0.890661 9.8087 1.13986 8.47049C1.38905 7.13228 1.96227 5.87548 2.8094 4.80998C3.65652 3.74449 4.75176 2.90272 5.99936 2.35829M17.666 9.99996C17.666 8.90561 17.4505 7.82198 17.0317 6.81093C16.6129 5.79988 15.9991 4.88122 15.2252 4.1074C14.4514 3.33358 13.5328 2.71975 12.5217 2.30096C11.5107 1.88217 10.427 1.66663 9.33269 1.66663V9.99996H17.666Z" 
                stroke={props.color || "#8C3F7D"}
                strokeWidth="1.67" 
                strokeLinecap="round" 
                strokeLinejoin="round" />
        </svg>

    )
}
